export const baseURL = "https://backend-genieaicreator.freedomuniversity.net/" // "https://backend.aistaffs.com/" 
export const appName = "Genieaicreator"
export const loginFooter = "-genieaicreator.freedomuniversity.net"  //NOTE DO NOT FORGET TO ADD . OR - FO THE URL
export const navBar = "-doitall.freedomuniversity.net"  //NOTE DO NOT FORGET TO ADD . OR - FO THE URL